import { SVGProps, memo } from 'react';
const ReplyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={props.width || "21"} height={props.height || "22"} viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Frame 1960">
      <path id="Vector 681" d="M17.5 16.4489V14.3414C17.5 11.764 15.4107 9.6747 12.8333 9.6747H3.5M3.5 9.6747L9.06725 4.78223M3.5 9.6747L9.06725 14.5672" stroke={props.stroke || "#424242"} strokeWidth={props.strokeWidth || "1.16667"} strokeLinecap="round"/>
    </g>
  </svg>

);

export default memo(ReplyIcon);
